<div class="flex h-screen min-h-0 flex-col gap-4 overflow-hidden p-4">

  <div class="flex shrink-0 items-start justify-between gap-4">

    <div class="min-w-0">

      <h1 class="text-xl font-semibold text-slate-900 flex items-center gap-2">

        {{ 'price_list.title' | translate }}

        <i class="pi pi-info-circle text-slate-400 text-lg" [pTooltip]="'price_list.header_hint' | translate" tooltipPosition="bottom"></i>

      </h1>

      <p class="mt-1 text-sm text-slate-600">

        {{ 'price_list.subtitle' | translate }}

      </p>

    </div>

    <div class="flex shrink-0 flex-wrap items-center justify-end gap-3">

      <app-button

        type="secondary"

        [outlined]="true"

        icon="download"

        [label]="'price_list.download_template' | translate"

        (emitOnClick)="downloadImportTemplate()"

      />

      <app-button

        type="info"

        [outlined]="false"

        icon="add"

        [label]="'price_list.import_from_file' | translate"

        (emitOnClick)="openImportDialog()"

      />

    </div>

  </div>



  <section class="price-search shrink-0" aria-labelledby="price-search-title">

    <h2 id="price-search-title" class="price-search-title">

      <i class="pi pi-search" aria-hidden="true"></i>

      {{ 'price_list.filters.title' | translate }}

    </h2>

    <form class="price-filters" (ngSubmit)="$event.preventDefault()">

    <label class="text-sm text-slate-700" for="price-sku-name">

      {{ 'price_list.filters.sku_name' | translate }}

      <input

        id="price-sku-name"

        pInputText

        class="w-full"

        [attr.placeholder]="'price_list.filters.sku_name_placeholder' | translate"

        [ngModel]="skuNameFilter()"

        (ngModelChange)="skuNameFilter.set($event); onFilterChange()"

        [ngModelOptions]="{ standalone: true }"

      />

    </label>

    <label class="text-sm text-slate-700" for="price-sku-code">

      {{ 'price_list.filters.sku_code' | translate }}

      <input

        id="price-sku-code"

        pInputText

        class="w-full"

        [attr.placeholder]="'price_list.filters.sku_code_placeholder' | translate"

        [ngModel]="skuCodeFilter()"

        (ngModelChange)="skuCodeFilter.set($event); onFilterChange()"

        [ngModelOptions]="{ standalone: true }"

      />

    </label>

    <label class="text-sm text-slate-700" for="price-amount-from">

      {{ 'price_list.filters.amount_from' | translate }}

      <p-inputNumber

        inputId="price-amount-from"

        styleClass="w-full"

        [placeholder]="'price_list.filters.amount_from_placeholder' | translate"

        [ngModel]="amountFrom()"

        (ngModelChange)="amountFrom.set($event); onFilterChange()"

        [ngModelOptions]="{ standalone: true }"

        [min]="0"

        [useGrouping]="true"

      />

    </label>

    <label class="text-sm text-slate-700" for="price-amount-to">

      {{ 'price_list.filters.amount_to' | translate }}

      <p-inputNumber

        inputId="price-amount-to"

        styleClass="w-full"

        [placeholder]="'price_list.filters.amount_to_placeholder' | translate"

        [ngModel]="amountTo()"

        (ngModelChange)="amountTo.set($event); onFilterChange()"

        [ngModelOptions]="{ standalone: true }"

        [min]="0"

        [useGrouping]="true"

      />

    </label>

    <label class="text-sm text-slate-700" for="price-filter-start">

      {{ 'price_list.filters.start_date' | translate }}

      <p-datepicker

        inputId="price-filter-start"

        dateFormat="dd/mm/yy"

        placeholder="dd/mm/yyyy"

        [showIcon]="true"

        styleClass="w-full"

        [ngModel]="filterStartDate()"

        (ngModelChange)="filterStartDate.set($event); onFilterChange()"

        [ngModelOptions]="{ standalone: true }"

      />

    </label>

    <label class="text-sm text-slate-700" for="price-filter-end">

      {{ 'price_list.filters.end_date' | translate }}

      <p-datepicker

        inputId="price-filter-end"

        dateFormat="dd/mm/yy"

        placeholder="dd/mm/yyyy"

        [showIcon]="true"

        styleClass="w-full"

        [ngModel]="filterEndDate()"

        (ngModelChange)="filterEndDate.set($event); onFilterChange()"

        [ngModelOptions]="{ standalone: true }"

      />

    </label>

    <label class="text-sm text-slate-700" for="price-filter-status">

      {{ 'price_list.filters.status' | translate }}

      <p-select

        inputId="price-filter-status"

        styleClass="w-full"

        [options]="statusFilterOptions"

        optionLabel="labelKey"

        optionValue="value"

        [ngModel]="statusFilter()"

        (ngModelChange)="statusFilter.set($event); onFilterChange()"

        [ngModelOptions]="{ standalone: true }"

        appendTo="body"

      >

        <ng-template #selectedItem let-selected>

          @if (selected) {

            {{ selected.labelKey | translate }}

          }

        </ng-template>

        <ng-template #item let-option>

          {{ option.labelKey | translate }}

        </ng-template>

      </p-select>

    </label>

    <p-button

      type="button"

      [label]="'search.form.actions.clear_filters' | translate"

      [outlined]="true"

      severity="secondary"

      size="small"

      (onClick)="clearSearch()"

    />

  </form>

  </section>



  <div

    class="flex shrink-0 gap-1 overflow-x-auto border-b border-slate-200"

    role="tablist"

    [attr.aria-label]="'price_list.tabs_label' | translate"

  >

    @for (tab of visibleTabs(); track tab.code; let index = $index) {

      <button

        type="button"

        role="tab"

        class="cursor-pointer shrink-0 border-b-2 px-3 py-2 text-sm transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 motion-reduce:transition-none"

        [class.border-blue-800]="activeCode() === tab.code"

        [class.text-blue-900]="activeCode() === tab.code"

        [class.font-semibold]="activeCode() === tab.code"

        [class.border-transparent]="activeCode() !== tab.code"

        [class.text-slate-600]="activeCode() !== tab.code"

        [attr.aria-selected]="activeCode() === tab.code"

        [attr.tabindex]="activeCode() === tab.code ? 0 : -1"

        (click)="selectTab(tab.code)"

        (keydown)="onTabKeydown($event, index)"

      >

        <span class="flex items-center gap-1">

          {{ tab.labelKey | translate }}

          @if (tab.hintKey) {

            <i class="pi pi-info-circle text-slate-400" [pTooltip]="tab.hintKey | translate" tooltipPosition="bottom"></i>

          }

        </span>

      </button>

    }

  </div>



  <div class="flex shrink-0 flex-col gap-2">

    <div class="flex flex-wrap items-center justify-end gap-2">

      @if (allowCreate()) {

        <button

          type="button"

          class="shrink-0 cursor-pointer rounded-md bg-blue-800 px-3 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300 motion-reduce:transition-none"

          [disabled]="!activeBook()"

          (click)="openCreate()"

        >

          {{ 'price_list.add' | translate }}

        </button>

      }

      @if (showBulkSelection() && canApprovePrice()) {

        <button

          type="button"

          class="shrink-0 cursor-pointer rounded-md border border-emerald-700 bg-white px-3 py-2 text-sm font-medium text-emerald-900 transition-colors duration-200 hover:bg-emerald-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-800 disabled:cursor-not-allowed disabled:border-slate-300 disabled:text-slate-400"

          [disabled]="!canBulkApprove() || bulkBusy()"

          (click)="openBulkConfirm('approve')"

        >

          {{ 'price_list.bulk.approve' | translate }}

        </button>

      }

      @if (showBulkSelection() && canDeletePrice()) {

        <button

          type="button"

          class="shrink-0 cursor-pointer rounded-md border border-rose-600 bg-white px-3 py-2 text-sm font-medium text-rose-800 transition-colors duration-200 hover:bg-rose-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-700 disabled:cursor-not-allowed disabled:border-slate-300 disabled:text-slate-400"

          [disabled]="!canBulkDelete() || bulkBusy()"

          (click)="openBulkConfirm('delete')"

        >

          {{ 'price_list.bulk.delete' | translate }}

        </button>

      }

      @if (showBulkDeactivate() && canDeactivatePrice()) {

        <button

          type="button"

          class="shrink-0 cursor-pointer rounded-md border border-slate-400 bg-white px-3 py-2 text-sm font-medium text-slate-800 transition-colors duration-200 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 disabled:cursor-not-allowed disabled:border-slate-300 disabled:text-slate-400"

          [disabled]="!canBulkDeactivate() || bulkBusy()"

          (click)="openBulkConfirm('deactivate')"

        >

          {{ 'price_list.bulk.deactivate' | translate }}

        </button>

      }

      @if (showBulkSelection() && canCancelPending()) {

        <button

          type="button"

          class="shrink-0 cursor-pointer rounded-md border border-rose-600 bg-white px-3 py-2 text-sm font-medium text-rose-800 transition-colors duration-200 hover:bg-rose-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-700 disabled:cursor-not-allowed disabled:border-slate-300 disabled:text-slate-400"

          [disabled]="!canBulkCancel() || bulkBusy()"

          (click)="openBulkConfirm('cancel')"

        >

          {{ 'price_list.bulk.cancel' | translate }}

        </button>

      }

    </div>

  </div>



  @if (error()) {

    <p role="alert" class="shrink-0 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800">

      {{ error()! | translate }}

    </p>

  }



  <div class="min-h-0 flex-1 overflow-auto rounded-md bg-white">

    <table class="price-table w-full min-w-[720px] text-left text-sm">

      <thead>

        <tr>

          @if (showBulkPicker()) {

            <th class="w-10 px-3 py-2">

              <p-checkbox

                [binary]="true"

                [ngModel]="allPageSelected()"

                (ngModelChange)="toggleSelectAllPage($event)"

                [ngModelOptions]="{ standalone: true }"

                [attr.aria-label]="'price_list.bulk.select_all' | translate"

              />

            </th>

          }

          <th class="px-3 py-2 font-medium">{{ 'price_list.sku' | translate }}</th>

          @if (activeCode() === 'COST_DEFAULT') {

            <th class="px-3 py-2 font-medium">{{ 'price_list.vendor' | translate }}</th>

          }

          @if (showProgram()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.program' | translate }}</th>

          }

          @if (showChannel()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.channel_name' | translate }}</th>

          }

          <th class="px-3 py-2 font-medium">{{ 'price_list.type' | translate }}</th>

          @if (showClearanceScopeColumn()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.scope.label' | translate }}</th>

          }

          @if (showMinQty()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.min_qty' | translate }}</th>

          }

          <th class="px-3 py-2 font-medium">{{ 'price_list.amount' | translate }}</th>

          @if (showDates()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.start_date' | translate }}</th>

            <th class="px-3 py-2 font-medium">{{ 'price_list.end_date' | translate }}</th>

          }

          @if (showRule()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.rule' | translate }}</th>

          }

          <th class="px-3 py-2 text-center font-medium">

            {{ 'price_list.status' | translate }}

          </th>

          @if (showPublished()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.published' | translate }}</th>

          }

          @if (showActions()) {

            <th class="px-3 py-2 font-medium">{{ 'price_list.actions' | translate }}</th>

          }

        </tr>

      </thead>

      <tbody>

        @if (loading()) {

          <tr>

            <td [attr.colspan]="columnCount()" class="px-3 py-6 text-slate-600">

              {{ 'price_list.loading' | translate }}

            </td>

          </tr>

        } @else if (items().length === 0) {

          <tr>

            <td [attr.colspan]="columnCount()" class="px-3 py-6 text-center text-slate-600">

              {{ 'price_list.empty' | translate }}

            </td>

          </tr>

        } @else {

          @for (item of items(); track item.id) {

            <tr>

              @if (showBulkPicker()) {

                <td class="px-3 py-2">

                  <p-checkbox

                    [binary]="true"

                    [ngModel]="isRowSelected(item.id)"

                    (ngModelChange)="toggleRowSelection(item.id, $event)"

                    [ngModelOptions]="{ standalone: true }"

                  />

                </td>

              }

              <td class="px-3 py-2">

                @if (item.skuName) {

                  <div class="font-semibold leading-5 text-slate-900">{{ item.skuName }}</div>

                }

                <div class="text-xs leading-4 text-slate-500">{{ item.skuCode }}</div>

              </td>

              @if (activeCode() === 'COST_DEFAULT') {

                <td class="px-3 py-2">

                  {{ vendorLabel(item.vendorId) }}

                  @if (item.primaryCostFlag) {

                    <span class="ml-1 text-xs text-slate-600">({{ 'price_list.primary' | translate }})</span>

                  }

                </td>

              }

              @if (showProgram()) {

                <td class="px-3 py-2">

                  @if (activeCode() === 'FLASH_SALE' && item.campaignId) {

                    <a

                      class="cursor-pointer text-blue-800 underline-offset-2 hover:underline"

                      [routerLink]="['/marketing/flash-sale', item.campaignId]"

                    >

                      {{ item.campaignName || programLabel(item.ruleJson) }}

                    </a>

                  } @else {

                    {{ programLabel(item.ruleJson) }}

                  }

                </td>

              }

              @if (showChannel()) {

                <td class="px-3 py-2">

                  @if (marketplaceShopId(item); as shopId) {

                    <a

                      class="cursor-pointer text-blue-800 underline-offset-2 hover:underline"

                      [routerLink]="['/channel/online-store/view', shopId]"

                    >

                      {{ marketplaceChannelLabel(item) }}

                    </a>

                  } @else {

                    {{ marketplaceChannelLabel(item) }}

                  }

                </td>

              }

              <td class="px-3 py-2">{{ ('price_list.types.' + item.priceType) | translate }}</td>

              @if (showClearanceScopeColumn()) {

                <td class="px-3 py-2">{{ clearanceScopeLabel(item) }}</td>

              }

              @if (showMinQty()) {

                <td class="px-3 py-2 tabular-nums">{{ item.minQty ?? 50 }}</td>

              }

              <td class="px-3 py-2 tabular-nums text-right">

                {{ item.amount | number: '1.0-0' }} {{ item.currencyCode || 'đ' }}

                @if (item.pendingAmount != null && item.pendingAmountStatus === 'PENDING') {

                  <div class="text-xs text-amber-800">

                    {{ 'price_list.pending_amount' | translate }}:

                    {{ item.pendingAmount | number: '1.0-0' }}

                  </div>

                }

              </td>

              @if (showDates()) {

                <td class="px-3 py-2 whitespace-nowrap">

                  {{

                    (item.startAt || item.effectiveFrom)

                      ? ((item.startAt || item.effectiveFrom) | date: 'dd/MM/yyyy HH:mm')

                      : '—'

                  }}

                </td>

                <td class="px-3 py-2 whitespace-nowrap">

                  @if (item.endAt || item.effectiveTo) {

                    {{ (item.endAt || item.effectiveTo) | date: 'dd/MM/yyyy HH:mm' }}

                  } @else {

                    {{ 'price_list.open_ended' | translate }}

                  }

                </td>

              }

              @if (showRule()) {

                <td class="px-3 py-2">{{ ruleLabel(item.ruleJson) }}</td>

              }

              <td class="px-3 py-2 text-center">

                <span

                  class="inline-flex items-center rounded px-2 py-0.5 text-xs font-medium"

                  [class.bg-emerald-100]="scheduleLabel(item) === 'price_list.status_active'"

                  [class.text-emerald-900]="scheduleLabel(item) === 'price_list.status_active'"

                  [class.bg-amber-100]="scheduleLabel(item) === 'price_list.schedule_scheduled' || scheduleLabel(item) === 'price_list.status_pending'"

                  [class.text-amber-950]="scheduleLabel(item) === 'price_list.schedule_scheduled' || scheduleLabel(item) === 'price_list.status_pending'"

                  [class.bg-slate-200]="scheduleLabel(item) === 'price_list.schedule_expired' || scheduleLabel(item) === 'price_list.status_inactive'"

                  [class.text-slate-800]="scheduleLabel(item) === 'price_list.schedule_expired' || scheduleLabel(item) === 'price_list.status_inactive'"

                >

                  {{ scheduleLabel(item) | translate }}

                </span>

              </td>

              @if (showPublished()) {

                <td class="px-3 py-2">

                  {{

                    (item.publishedFlag

                      ? 'price_list.published_yes'

                      : 'price_list.published_no'

                    ) | translate

                  }}

                </td>

              }

              @if (showActions()) {

                <td class="px-3 py-2">

                  @if (canEditBasePrice() && !isStopped(item)) {

                    <button

                      type="button"

                      class="cursor-pointer text-blue-800 underline-offset-2 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"

                      (click)="openEdit(item)"

                    >

                      {{ 'price_list.edit' | translate }}

                    </button>

                  }

                  @if (isStopped(item) && canDeletePrice()) {

                    <button

                      type="button"

                      class="ml-2 cursor-pointer text-rose-700 underline-offset-2 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-700"

                      (click)="deleteStopped(item)"

                    >

                      {{ 'price_list.delete' | translate }}

                    </button>

                  }

                  @if (isPendingApproval(item) && canApprovePrice()) {

                    <button

                      type="button"

                      class="ml-2 cursor-pointer text-emerald-800 underline-offset-2 hover:underline"

                      (click)="approveItem(item)"

                    >

                      {{ 'price_list.approve' | translate }}

                    </button>

                  }

                  @if (isPendingApproval(item) && canCancelPending()) {

                    <button

                      type="button"

                      class="ml-2 cursor-pointer text-rose-700 underline-offset-2 hover:underline"

                      (click)="cancelPending(item)"

                    >

                      {{ 'price_list.cancel_pending' | translate }}

                    </button>

                  }

                  @if (isLiveEffective(item) && canDeactivatePrice()) {

                    <button

                      type="button"

                      class="ml-2 cursor-pointer text-slate-700 underline-offset-2 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"

                      (click)="deactivateItem(item)"

                    >

                      {{ 'price_list.deactivate' | translate }}

                    </button>

                  }

                  @if (

                    activeCode() === 'FLASH_SALE' &&

                    item.pendingAmount != null &&

                    item.pendingAmountStatus === 'PENDING' &&

                    canApprovePrice()

                  ) {

                    <button

                      type="button"

                      class="ml-2 cursor-pointer text-emerald-800 underline-offset-2 hover:underline"

                      (click)="approveFlashAmount(item)"

                    >

                      {{ 'price_list.approve' | translate }}

                    </button>

                  }

                </td>

              }

            </tr>

          }

        }

      </tbody>

    </table>

  </div>



  @if (total() > 0) {

    <div class="flex shrink-0 items-center justify-end gap-4 text-sm text-gray-400">

      <p-paginator

        [rows]="pageSize()"

        [first]="page() * pageSize()"

        [totalRecords]="total()"

        [rowsPerPageOptions]="rowsPerPageOptions"

        [showCurrentPageReport]="true"

        [currentPageReportTemplate]="

          'common.table.pagination.current_page_report' | translate

        "

        (onPageChange)="onTablePage($event)"

        class="p-paginator"

        [appendTo]="'body'"

      />

      <div class="mr-4 flex items-center gap-2">

        <span class="text-sm text-gray-500">{{

          "common.table.pagination.go" | translate

        }}</span>

        <input

          type="number"

          [ngModel]="goToPageNumber()"

          (ngModelChange)="goToPageNumber.set($event)"

          [min]="1"

          [max]="maxPage()"

          (keyup.enter)="onGoToPage()"

          (blur)="onGoToPage()"

          class="h-9 w-16 rounded border px-2 text-center"

        />

        <span class="text-sm text-gray-500">{{

          "common.table.pagination.page" | translate

        }}</span>

      </div>

    </div>

  }

</div>



<p-toast />



<p-dialog

  [header]="(editingItem() ? 'price_list.edit_line' : 'price_list.add') | translate"

  [visible]="dialogOpen()"

  (visibleChange)="dialogOpen.set($event)"

  [modal]="true"

  [style]="{ width: '36rem' }"

  [contentStyle]="{ overflow: 'visible' }"

  [draggable]="false"

>

  <form class="flex flex-col gap-3" [formGroup]="form" (ngSubmit)="save()">

    @if (!editingItem()) {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        <span>

          {{ 'price_list.sku_name' | translate }}

          <span class="text-red-600">*</span>

        </span>

        <p-select

          formControlName="skuCode"

          [options]="skuOptions()"

          optionLabel="skuName"

          optionValue="skuCode"

          [filter]="true"

          filterBy="skuName,skuCode"

          [loading]="skuOptionsLoading()"

          [placeholder]="'price_list.sku_placeholder' | translate"

          [emptyMessage]="'price_list.sku_empty' | translate"

          [emptyFilterMessage]="'price_list.sku_empty' | translate"

          appendTo="body"

          styleClass="w-full"

          [virtualScroll]="skuOptions().length > 50"

          [virtualScrollItemSize]="44"

          scrollHeight="240px"

          (onChange)="onSkuSelected($event.value)"

        >

          <ng-template #item let-sku>

            <span class="flex flex-col py-1">

              <span>{{ sku.skuName }}</span>

              <span class="text-xs text-slate-500">{{ sku.skuCode }}</span>

            </span>

          </ng-template>

        </p-select>

      </label>

    } @else {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        <span>

          {{ 'price_list.sku' | translate }}

          <span class="text-red-600">*</span>

        </span>

        <input pInputText formControlName="skuCode" />

      </label>

    }

    @if (form.controls.skuCode.value && activeCode() !== 'COST_DEFAULT') {

      <p class="text-xs text-slate-600">

        {{ 'price_list.current_cost' | translate }}:

        @if (selectedSkuCostLoading()) {

          …

        } @else if (selectedSkuCost() != null) {

          <span class="font-medium tabular-nums text-slate-800">

            {{ selectedSkuCost() | number: '1.0-0' }} VND

          </span>

        } @else {

          {{ 'price_list.current_cost_missing' | translate }}

        }

      </p>

      @if (showRetailReference()) {

        <p class="text-xs text-slate-600">

          {{ 'price_list.current_retail' | translate }}:

          @if (selectedSkuRetailLoading()) {

            …

          } @else if (selectedSkuRetail() != null) {

            <span class="font-medium tabular-nums text-slate-800">

              {{ selectedSkuRetail() | number: '1.0-0' }} VND

            </span>

          } @else {

            <span class="text-red-600">{{ 'price_list.errors.retail_required' | translate }}</span>

          }

        </p>

        @if (!selectedSkuRetailLoading() && selectedSkuRetail() == null) {

          <p class="text-xs text-red-600">{{ 'price_list.retail_required_hint' | translate }}</p>

        }

      }

    }

    @if (showMinQty()) {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        <span>

          {{ 'price_list.min_qty' | translate }}

          <span class="text-red-600">*</span>

        </span>

        <p-inputNumber formControlName="minQty" [min]="1" styleClass="w-full" />

      </label>

    }

    @if (!activeTab().allowRule || form.controls.ruleType.value === 'FIXED') {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        <span>

          {{ 'price_list.amount' | translate }}

          <span class="text-red-600">*</span>

        </span>

        <p-inputNumber formControlName="amount" [min]="0" styleClass="w-full" />

        <span class="text-xs text-slate-500">

          {{

            (activeCode() === 'CLEARANCE'

              ? 'price_list.clearance_amount_hint'

              : 'price_list.amount_hint'

            ) | translate

          }}

        </span>

      </label>

    }

    @if (activeTab().allowRule) {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        <span>

          {{ 'price_list.rule' | translate }}

          <span class="text-red-600">*</span>

        </span>

        <p-select

          formControlName="ruleType"

          [options]="ruleOptions()"

          optionLabel="label"

          optionValue="value"

          appendTo="body"

        />

      </label>

      @if (form.controls.ruleType.value !== 'FIXED') {

        <label class="flex flex-col gap-1 text-sm text-slate-700">

          <span>

            {{ 'price_list.rate' | translate }}

            <span class="text-red-600">*</span>

          </span>

          <p-inputNumber

            formControlName="ratePercent"

            [min]="0"

            [max]="100"

            suffix="%"

            styleClass="w-full"

          />

        </label>

      }

    }

    @if (showClearanceScope()) {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        <span>

          {{ 'price_list.scope.label' | translate }}

          <span class="text-red-600">*</span>

        </span>

        <p-select

          formControlName="scopeType"

          [options]="scopeOptions()"

          optionLabel="label"

          optionValue="value"

          appendTo="body"

          styleClass="w-full"

        />

      </label>

      @if (form.controls.scopeType.value === 'SELECTED_STORES') {

        <label class="flex flex-col gap-1 text-sm text-slate-700">

          <span>

            {{ 'price_list.scope.stores' | translate }}

            <span class="text-red-600">*</span>

          </span>

          <p-multiSelect

            formControlName="physicalShopIds"

            [options]="shopOptions()"

            optionLabel="name"

            optionValue="id"

            [filter]="true"

            appendTo="body"

            styleClass="w-full"

            [placeholder]="'price_list.scope.stores_placeholder' | translate"

          />

        </label>

      }

    }

    @if (showMarketSource()) {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        {{ 'price_list.market_source' | translate }}

        <input

          pInputText

          formControlName="marketSource"

          [attr.placeholder]="'price_list.market_source_placeholder' | translate"

        />

      </label>

    }

    @if (showDates() && !editingFlashSale()) {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        <span>

          {{ 'price_list.start_date' | translate }}

          <span class="text-red-600">*</span>

        </span>

        <app-advanced-datepicker

          formControlName="startAt"

          mode="single"

          [showTime]="true"

          timeFormat="24h"

          dateFormat="DD/MM/YYYY"

          placeholder="dd/mm/yyyy HH:mm"

          [minDate]="minSelectableDate"

          class="w-full text-sm"

        />

      </label>

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        {{ 'price_list.end_date' | translate }}

        <app-advanced-datepicker

          formControlName="endAt"

          mode="single"

          [showTime]="true"

          timeFormat="24h"

          dateFormat="DD/MM/YYYY"

          placeholder="dd/mm/yyyy HH:mm"

          [minDate]="minSelectableDate"

          class="w-full text-sm"

        />

        <span class="text-xs text-slate-500">{{ 'price_list.end_optional' | translate }}</span>

      </label>

    }

    @if (activeCode() !== 'FLASH_SALE' && activeCode() !== 'MARKETPLACE') {

      <label class="flex flex-col gap-1 text-sm text-slate-700">

        {{ 'price_list.change_reason' | translate }}

        <p-select

          formControlName="changeReason"

          [options]="reasonOptions()"

          optionLabel="label"

          optionValue="value"

          appendTo="body"

          styleClass="w-full"

          [placeholder]="'price_list.change_reason_placeholder' | translate"

        />

      </label>

    }

    @if (!editingItem()) {

    <p class="text-xs text-slate-600">{{ 'price_list.draft_hint' | translate }}</p>

    }

    <div class="flex justify-end gap-2">

      <button

        type="button"

        class="cursor-pointer rounded-md px-3 py-2 text-sm text-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"

        (click)="dialogOpen.set(false)"

      >

        {{ 'price_list.cancel' | translate }}

      </button>

      <button

        type="submit"

        class="cursor-pointer rounded-md bg-blue-800 px-3 py-2 text-sm font-medium text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300"

        [disabled]="!canSaveForm()"

      >

        {{ 'price_list.save' | translate }}

      </button>

    </div>

  </form>

</p-dialog>



<p-dialog

  [header]="bulkConfirmTitleKey() | translate"

  [modal]="true"

  [draggable]="false"

  [resizable]="false"

  [style]="{ width: '28rem' }"

  [visible]="bulkConfirmOpen()"

  (visibleChange)="bulkConfirmOpen.set($event)"

>

  <p class="text-sm text-slate-700">

    {{

      bulkConfirmBodyKey()

        | translate: { eligible: bulkConfirmEligibleCount(), selected: selectedItems().length }

    }}

  </p>

  <div class="mt-4 flex justify-end gap-2">

    <button

      type="button"

      class="cursor-pointer rounded-md px-3 py-2 text-sm text-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800"

      [disabled]="bulkBusy()"

      (click)="bulkConfirmOpen.set(false)"

    >

      {{ 'price_list.cancel' | translate }}

    </button>

    <button

      type="button"

      class="cursor-pointer rounded-md bg-blue-800 px-3 py-2 text-sm font-medium text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-800 disabled:cursor-not-allowed disabled:bg-slate-300"

      [disabled]="bulkBusy() || bulkConfirmEligibleCount() === 0"

      (click)="confirmBulkAction()"

    >

      {{ 'price_list.bulk.confirm' | translate }}

    </button>

  </div>

</p-dialog>



<p-dialog

  [visible]="importDialogOpen()"

  [modal]="true"

  [closable]="false"

  [draggable]="false"

  [resizable]="false"

  [style]="{ width: '90vw', maxWidth: '800px' }"

  (onHide)="closeImportDialog()"

>

  <ng-template pTemplate="header">

    <div class="flex w-full items-center justify-between">

      <h2 class="m-0 text-xl font-semibold text-gray-800">

        {{ 'price_list.import.title' | translate }}

      </h2>

      <button

        type="button"

        class="custom-close-btn"

        (click)="closeImportDialog()"

        [attr.aria-label]="'common.actions.close_dialog' | translate"

      >

        <svg

          class="h-6 w-6"

          viewBox="0 0 24 24"

          fill="none"

          stroke="currentColor"

          stroke-width="2"

          stroke-linecap="round"

          stroke-linejoin="round"

        >

          <line x1="18" y1="6" x2="6" y2="18"></line>

          <line x1="6" y1="6" x2="18" y2="18"></line>

        </svg>

      </button>

    </div>

  </ng-template>



  <div class="max-w-4xl mx-auto p-0 pt-4">

    <p-card>

      <ng-template pTemplate="header">

        <div class="border-b border-gray-200 p-4">

          <h3 class="text-lg font-semibold text-gray-900">

            {{ 'price_list.import.rule_file_title' | translate }}

          </h3>

          <p class="mt-1 text-sm text-gray-600">

            {{ 'price_list.import.rule_file_description' | translate }}

          </p>

        </div>

      </ng-template>

      <div class="space-y-4">

        <app-file-upload

          #importFileUpload

          [placeholder]="'price_list.import.file_upload_placeholder' | translate"

          accept=".xlsx,.xls"

          [acceptedTypes]="'.xlsx,.xls'"

          (fileChange)="onImportFileChanged($event)"

        />

      </div>

    </p-card>

  </div>



  <ng-template pTemplate="footer">

    <div class="flex items-center justify-end gap-3">

      <app-button

        [label]="'common.actions.cancel' | translate"

        type="secondary"

        [outlined]="true"

        (emitOnClick)="closeImportDialog()"

      />

      <app-button

        [label]="'price_list.import.create_button' | translate"

        type="info"

        [disabled]="importBusy() || !canSubmitImport()"

        [loading]="importBusy()"

        (emitOnClick)="confirmImportFromFile()"

      />

    </div>

  </ng-template>

</p-dialog>

